export default "__VITE_ASSET__D0GQQY9H__"